import moment from "moment";

class LoggerDecorator {

    public static $inject: string[] = ["$provide"];

    constructor($provide) {
        $provide.decorator(
            "$log",
            ["$delegate", "configService", "loggerService", ($delegate, configService, loggerService) => {

                ["log", "info", "warn", "error", "debug"].forEach(method => {
                    const originalMethod = $delegate[method];

                    const level = method === "log" ? "info" : method;

                    $delegate[method] = function handleLogMessage(message) {
                        if (configService.logs.pushToServer.indexOf(level) !== -1) {
                            loggerService.pushLog({
                                "datetime": moment().format("YYYY-MM-DDTHH:mm:ss,SSSZ"),
                                "level": level,
                                "data": arguments
                            });
                        }

                        originalMethod.apply(null, arguments);
                    };
                });

                return $delegate;
        }]);
    }
}

angular
    .module("thor.core.logger.decorator", [])
    .config(LoggerDecorator);
